import { apiFetch } from "./apiFetch";

interface SandboxTokenResponse {
	token: string; // prefixed nova_sbx_
}

export async function getSandboxToken(
	modelConfigId?: string,
): Promise<SandboxTokenResponse> {
	const url = modelConfigId
		? `/playground/sandbox-token?modelConfigId=${encodeURIComponent(modelConfigId)}`
		: "/playground/sandbox-token";
	return apiFetch<SandboxTokenResponse>(url);
}
